// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/chat/v1/portal_service.proto (package spwn.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from message spwn.chat.v1.PortalChatServiceSaveStreamingAnnouncementRequest
 */
export class PortalChatServiceSaveStreamingAnnouncementRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string video_id = 1;
         */
        this.videoId = "";
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        /**
         * @generated from field: string event_id = 3;
         */
        this.eventId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalChatServiceSaveStreamingAnnouncementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalChatServiceSaveStreamingAnnouncementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalChatServiceSaveStreamingAnnouncementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalChatServiceSaveStreamingAnnouncementRequest, a, b);
    }
}
PortalChatServiceSaveStreamingAnnouncementRequest.runtime = proto3;
PortalChatServiceSaveStreamingAnnouncementRequest.typeName = "spwn.chat.v1.PortalChatServiceSaveStreamingAnnouncementRequest";
PortalChatServiceSaveStreamingAnnouncementRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.chat.v1.PortalChatServiceSaveStreamingAnnouncementResponse
 */
export class PortalChatServiceSaveStreamingAnnouncementResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalChatServiceSaveStreamingAnnouncementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalChatServiceSaveStreamingAnnouncementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalChatServiceSaveStreamingAnnouncementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalChatServiceSaveStreamingAnnouncementResponse, a, b);
    }
}
PortalChatServiceSaveStreamingAnnouncementResponse.runtime = proto3;
PortalChatServiceSaveStreamingAnnouncementResponse.typeName = "spwn.chat.v1.PortalChatServiceSaveStreamingAnnouncementResponse";
PortalChatServiceSaveStreamingAnnouncementResponse.fields = proto3.util.newFieldList(() => []);
//# sourceMappingURL=portal_service_pb.js.map